const getSelectedLanguage = state => state.selectedLanguage;

export default {
  getSelectedLanguage,
};
